import { Button, Upload } from "antd";
import { useEffect, useState } from "react";
import { mUtils } from "../../../../../helper/utils";
import { FileResponse } from "../../../customer/entity/customer.model";
import { fileService } from "../../../shared/service/file.service";
import { LabDocumentModel, Product } from "../../entity/product.model";
import { productService } from "../../service/product.service";

export interface LabDocumentProps {
  product: Product;
  value?: LabDocumentModel[];
  disabled: boolean;
}

function LabDocument(props: LabDocumentProps) {
  const [fileList, setFileList] = useState<any[]>([]);

  useEffect(() => {
    if (props.value) {
      setFileList(
        props.value.map((x) => {
          return {
            uid: x.uuid,
            name: x.fileName,
            status: "done",
            url: mUtils.getPublicFileAbsolutePath(x.filePath),
          };
        })
      );
    }

    return () => {
      setFileList([]);
    };
  }, [props.value]);

  const onUpload = async (options: any) => {
    const { onSuccess, file, onProgress } = options;

    fileService.uploadFile(file, true).then((fileReponse: FileResponse) => {
      productService
        .addDocument(props.product.uuid, {
          fileName: file.name,
          filePath: fileReponse.fileName,
        })
        .then((document: LabDocumentModel) => {
          file.url = mUtils.getPublicFileAbsolutePath(document.filePath);
          file.status = "done";
          fileList.push(file);
          setFileList(fileList);
          onProgress({ percent: 100 });
          onSuccess(file);
        });
    });
  };

  const onRemove = async (file: any) => {
    productService.deleteDocument(file.uid).then(() => {
      const _fileList = fileList?.filter((x) => x.status !== "removed");
      setFileList(_fileList);
    });
  };

  return (
    <>
      <Upload
        disabled={props.disabled}
        multiple={true}
        fileList={fileList}
        customRequest={onUpload}
        onRemove={onRemove}
      >
        <Button>Хуулах</Button>
      </Upload>
    </>
  );
}

export default LabDocument;
